import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setMobileMenuOpen(false);
    }
  };

  const navItems = [
    { name: 'Home', id: 'home' },
    { name: 'What We Offer', id: 'services' },
    { name: 'Our Community', id: 'community' },
    { name: 'Host an Event', id: 'host-event' },
    { name: 'Partner With Us', id: 'partnerships' },
    { name: 'Contact', id: 'contact' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-200" data-testid="header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <button onClick={() => scrollToSection('home')} className="flex items-center" data-testid="logo-link">
            <img 
              src="https://customer-assets.emergentagent.com/job_84a4a60d-7b7a-4891-9b3e-916a052c67d8/artifacts/mqmr6ogp_CoPlay%20Logo%20%28Blue%29%4033.33x-8.png" 
              alt="CoPlay Logo" 
              className="h-12 w-auto"
            />
          </button>

          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-base font-medium text-slate-600 hover:text-blue-600 transition-colors"
                data-testid={`nav-link-${item.id}`}
              >
                {item.name}
              </button>
            ))}
          </nav>

          <div className="hidden md:block">
            <Button
              data-testid="header-book-btn"
              onClick={() => scrollToSection('locations')}
              className="bg-blue-600 hover:bg-blue-700 text-white rounded-full px-6 font-semibold"
            >
              Book Now
            </Button>
          </div>

          <button
            className="md:hidden text-slate-900"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-slate-200" data-testid="mobile-menu">
          <nav className="px-4 py-4 space-y-4">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="block w-full text-left text-base font-medium py-2 text-slate-600"
                data-testid={`mobile-nav-link-${item.id}`}
              >
                {item.name}
              </button>
            ))}
            <Button
              data-testid="mobile-book-btn"
              onClick={() => scrollToSection('locations')}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded-full font-semibold"
            >
              Book Now
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;